import { Car } from 'lucide-react'

export const Logo = () => {
  return (
    <div className="flex items-center gap-2">
      <div className="bg-accent p-2 rounded-lg">
        <Car className="h-6 w-6 text-accent-foreground" />
      </div>
      <span className="text-xl font-bold text-foreground">Bil+</span>
    </div>
  )
}
